import axios from "axios";
export * from "./collages";
export * from "./products";
export * from "./config";
export * from "./design";
export * from "./cart";


axios.interceptors.request.use(function (config) {
  if (window?.DeskpadData?.nonce) {
    config.headers["X-WP-Nonce"] = window.DeskpadData.nonce;
  }
  return config;
});
